import Slider from "../components/Slider"
import Overlay from "../components/Overlay"
import Footer from "../components/Footer"
import Carousel from "../components/Carousel"
import Promoted from "../components/Promoted"
import useProducts from "../context/ProductsContext"

export const cultures = [
  { img: "/imgs/culture1.jpg", title: "Air Jordan X Dallol" },
  { img: "/imgs/culture2.jpg", title: "Yezzy X Dallol" },
  { img: "/imgs/culture3.jpg", title: "Podcast: lordx, ep: 128" },
  { img: "/imgs/culture4.jpg", title: "Samba Lounge X Dallol" },
  // { img: "/imgs/culture5.jpg", title: "Everyday Sneakers X Dallol" },
  { img: "/imgs/culture6.jpg", title: "Magic shoe X Dallol" },
  // { img: "/imgs/culture7.jpg", title: "Shop Floor X Dallol" },
  // { img: "/imgs/culture8.jpg", title: "Chillax X Dallol" },
]

const Home = () => {
  const { products, isLoading } = useProducts()

  const featured = products?.slice(0, 7)
  const newDropSlides = products?.slice(8, 14)
  const jordansSlides = products?.filter((p) => {
    return p.categories?.some((c) => {
      return c["name"] === "Air jordan"
    })
  })
  const forceSlides = products
    ?.filter((p) => {
      return p.categories?.some((c) => {
        return c["name"] === "Low top"
      })
    })
    .slice(4)

  return (
    <>
      <Carousel />
      <Slider title="Featured" slides={featured} isLoading={isLoading} />
      <Overlay />
      <Slider title="New Drops" slides={newDropSlides} isLoading={isLoading} />
      <Slider
        title="Air Jordans"
        padSm
        slides={jordansSlides}
        isLoading={isLoading}
      />
      <Promoted />
      <Slider
        title="Sneakers"
        padTo
        slides={forceSlides}
        isLoading={isLoading}
      />
      <Slider title="Culture" culture slides={cultures} />
      <Footer />
    </>
  )
}

export default Home
